module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-6.d4ce8005.jpg";